import React, { Component } from 'react';
import Modal from '../../commons/Modal/Modal';
import config from '../../../config';
import axios from 'axios';
import { TextInputField, TextAreaField } from '../../commons/Inputs';

let $ = window.jQuery;

export default class SMSModal extends Component {
    state = {
        isSaving: false,
        message: '',
        sms_templates: [],
        sms_template: 0,
        withSMS: false,
        withEmail: true
    };

    getSMSTemplate = () => {
        let url = `${config.apiUrl}sms-templates`;

        axios.get(url).then((res) => {
            this.setState({
                sms_templates: res.data.data
            });
        }).catch((error) => {
            console.log(error);
        });
    };

    handleSendSMS = () => {
        this.setState({
            isSaving: true
        });

        let patientId = this.props.smsData.id;

        let url = `${config.apiUrl}patients/${patientId}/sms`;
        let data = {
            message: this.state.message
        };

        axios.post(url, data).then((res) => {
            console.log(res);

            this.setState({
                isSaving: false
            });

            $('#smsModal').modal('hide');

            this.props.showNotification('success', 'SMS Sent');


        }).catch((error) => {
            console.log(error.response);

            this.setState({
                isSaving: false
            });

            $('#smsModal').modal('hide');
            this.props.showNotification('error', 'Failed in sending an SMS Message');
        });
    };

    handleCloseModal = () => {

    };

    handleChange = (e) => {
        let data = {};
        data[e.target.id] = e.target.value;
        data['message'] = e.target.value;

        this.setState(data);
    };

    handleEmailAndSMSCheckbox = (e) => {
        console.log(e.target.id);
        if (e.target.id === 'withSMS') {
            this.setState({
                withSMS: !this.state.withSMS
            });

        } else {
            this.setState({
                withEmail: !this.state.withEmail
            });
        }
    };

    componentDidMount() {
        this.getSMSTemplate();
    }

    render() {
        let content = '';
        let name = '';

        if (this.props.smsData !== null) {

            if (typeof this.props.smsData.name === 'undefined') {
                if (typeof this.props.smsData.user !== 'undefined') {
                    name = `${this.props.smsData.user.firstname} ${this.props.smsData.user.lastname}`;
                }
            } else {
                name = this.props.smsData.name;
            }

            content = (
                <form id="sendSMS" method="POST">
                    <TextInputField val={name} id="to" label="To" help="Patient Mobile Number"/>

                    <div className="form-group form-md-line-input">
                        <select type="text" className="form-control"
                                value={this.state.sms_template}
                                onChange={this.handleChange}
                                id="sms_template">

                            {this.state.sms_templates.map((template, i) => {
                                return (
                                    <option value={template.content} key={i}>{template.title}</option>
                                )
                            })}
                        </select>

                        <label htmlFor="sms_template">SMS Template</label>
                        <span className="help-block">Select a template</span>
                    </div>

                    <TextAreaField val={this.state.message} onChange={(e) => this.setState({message: e.target.value})}
                                   id="messageArea" label="Content" help="Message Content"/>

                    <div className="col-md-12">
                        <div className="md-checkbox-list">
                            <div className="md-checkbox" style={{ float: 'left' }}>
                                <input type="checkbox" name="withSMS" id="withSMS" className="md-check"
                                       checked={this.state.withSMS}
                                       onChange={this.handleEmailAndSMSCheckbox}
                                       value={this.state.withSMS} />

                                <label htmlFor="withSMS">
                                    <span/>
                                    <span className="check"/>
                                    <span className="box"/> SMS </label>
                            </div>
                        </div>

                        <div className="md-checkbox-list">
                            <div className="md-checkbox" style={{ float: 'left', marginLeft: '20px' }}>
                                <input type="checkbox" name="withEmail" id="withEmail" className="md-check"
                                       checked={this.state.withEmail}
                                       onChange={this.handleEmailAndSMSCheckbox}
                                       value={this.state.withEmail} />

                                <label htmlFor="withEmail">
                                    <span/>
                                    <span className="check"/>
                                    <span className="box"/> Email </label>
                            </div>
                        </div>
                    </div>
                </form>
            );
        }

        return (
            <Modal id="smsModal" header="Send SMS"
                   positiveButton="Send" negativeButton="Cancel"
                   width="600"
                   onPositiveClickEvent={this.handleSendSMS}
                   onNegativeClickEvent={this.handleCloseModal}
                   isSaving={this.state.isSaving}>

                {content}
            </Modal>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/SMSModal.js
 **/